/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import InputText from '../../atoms/inputText/inputText';
import FormInputTypes, { FormInputTypeCheck } from '../../atoms/formEnums/formInputTypes';
import FormValidation from '../../atoms/formEnums/formValidation';
import FormSelect from '../formSelect/formSelect';
import Select from '../../atoms/select/select';
import Radio from '../../atoms/radio/radio';
import Checkbox from '../../atoms/checkbox/checkbox';
import FormLoadOtherResource from '../formLoadOtherResouce/formLoadOtherResource';
import FormRelationship from '../../organisms/formRelationship/formRelationship';
import FormInputRelationship from '../../organisms/formInputRelationship/formInputRelationship';
import FormExternalResource from '../../molecules/formExternalResource/formExternalResource';
import FormStatus from '../formStatus/formStatus';
import Audio from '../../atoms/audio/audio';
import Timestamp from '../../atoms/timestamp/timestamp';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import ExternalLink from '../../atoms/externalLink/externalLink';
import Flag from '../../atoms/flag/flag';
import FormMoreInfo from '../formMoreInfo/formMoreInfo';
import PlayerIcon from '../../atoms/playerIcon/playerIcon';
import TextEditor from '../../atoms/textEditor/textEditor';
import ButtonPopup from '../../atoms/buttonPopup/buttonPopup';
import ExternalFrame from '../../atoms/externalFrame/externalFrame';
import Time from '../../atoms/time/time';
import FormTag from '../formTag/formTag';
import FormRelationshipFilter from '../../organisms/formRelationship/formRelationshipFilter';
import { isArray } from 'lodash';
import SingleTagPreview from '../formTagsPreview/singleTagPreview';
import FormCellDate from '../formCellDate/formCellDate';
import FormDatePartialPicker from '../formDatePartialPicker/formDatePartialPicker';
import IconCheckbox from '../../atoms/iconCheckbox/iconCheckbox';
import FormAuditChanges from '../../organisms/formAuditChange/FormAuditChanges';

const TableCell = (props) => {
  const {
    id,
    configFile,
    dataSetIndex,
    value,
    secondaryValue,
    canEdit,
    width,
    exactWidth,
    hidden,
    small,
    dataSet,
    onChange,
    onChangeAndRefresh,
    onChangeAndRefreshRecord,
    onChangeInputRelationship,
    onChangeStatus,
    fileType,
    onEnableWhen,
    pattern,
    colors,
    hasSelect,
    buttonText,
    valueButton,
    textAreYouSure,
    actionUrl,
    relatedId,
    disabled,
    additionalCss,
    refreshRowOnChange,
    sessionParams,
  } = props;

  const type = configFile.type ? configFile.type : FormInputTypes.TEXT_INPUT.TEXT;
  const name = configFile.attributeName;
  const { icon } = configFile;
  const { label } = configFile;
  const { enabledWhen } = configFile;
  const blockInput = configFile.blockInput ? configFile.blockInput : false;
  const options = configFile.options ? configFile.options : null;
  const multiple = configFile.multiple ? configFile.multiple : false;
  const classNameCell = configFile.classNameCell ? configFile.classNameCell : '';
  const childRef = useRef();
  
  const handleEnabledWhen = () => { 
    if(enabledWhen){
      if(dataSet && dataSet[dataSetIndex]){
        if(dataSet[dataSetIndex][enabledWhen.field]===enabledWhen.values){
          return false;
        }
        if(enabledWhen.values === "not-null" && (dataSet[dataSetIndex]?.[enabledWhen.field]!==null)){
          return false;
        }
        else
        {
          return true;
        }
      }
    }        
    
    return false;
  }

  const handleParentEnabledWhen = () => {
    if(enabledWhen && onEnableWhen){
      return (onEnableWhen(enabledWhen));
    }
    return false;

  }
  
  const handleInputRelationshipChange = (newValue,additionalValues = null) => {
    let finalValue=newValue.target.value;
    if(isArray(finalValue) && finalValue.length==1){
      finalValue=finalValue[0];
    }
    const callback = {
      dataSetIndex,
      newValue: finalValue,
    };
    
    onChangeInputRelationship(callback,additionalValues);
  };
  const handleStatusChange = (newValue) => {
    const callback = {
      dataSetIndex:dataSet[dataSetIndex].id,
      newValue: newValue.newValue,
    };
    onChangeStatus(callback);
  };
  const handleChangeExternal=(e,data)=>{
    onChangeAndRefresh(data);
  }
  const handleChange = (newValue, additionalValues = null) => {
    if (type === FormInputTypes.TEXT_OR_RELATIONSHIP) {
        handleInputRelationshipChange(newValue,additionalValues);
      
    } else if(type === FormInputTypes.DOWNLOADABLE){
      const callback = {
        dataSetIndex,
        newValue: newValue.id,
        name,
      };
      onChange(callback);
    } else {
      const callback = {
        dataSetIndex,
        newValue: (type === FormInputTypes.CHECKBOX || type === FormInputTypes.RADIO)
          ? newValue.target.checked : newValue.target.value,
        name,
      };
      
      if(refreshRowOnChange){
        onChangeAndRefreshRecord(callback);
      }else
        onChange(callback);
      
    }
  };

  const UpdateInputs = () => {
    if (canEdit && childRef.current !== undefined) {
      // eslint-disable-next-line no-unused-expressions
      childRef?.current?.updateValue(value);
    }
  };

  useEffect(() => {
    UpdateInputs();
  });
  const checkIconWhen=(v)=>{
    if(v.field){
      if(dataSet && dataSet[dataSetIndex] && dataSet[dataSetIndex][v.field]==v.value){
        if(v.icon){
          return {"icon":v.icon,"enabled":v.enabled};
        }
        else
          return {"customIcon":v.customIcon,"enabled":v.enabled};
      }else{
        return checkIconWhen(v.else);
      }
    }else{
      if(v.icon)
        return {"icon":v.icon,"enabled":v.enabled};
      else{
        return {"customIcon":v.customIcon,"enabled":v.enabled};
      }
    }
  }

  let contenCell = value;
   
  if(type==FormInputTypes.TEXT_INPUT.TEXT_COMMA){
    contenCell=(
      <span>{(value?value.split(",").length+ " elements":"(No elements)")}</span>
    );
  }

  if (canEdit) {
    let disableFieldWhen=false;
    if(configFile.enabledWhen){
      if(dataSet && dataSet[dataSetIndex]){
        let f=configFile.enabledWhen.field;
        let values=configFile.enabledWhen.values;
        if(values){
            if(values.includes(dataSet[dataSetIndex][configFile.enabledWhen.field]))
              disableFieldWhen=false;
            else
              disableFieldWhen=true;
        }
      }
    }        
    switch (type) {
      case FormInputTypes.ICON_CHECKBOX:
        contenCell=(
          <IconCheckbox 
            id={id}
            className={(configFile.className?configFile.className:'')+" table__checkbox-radio"}
            ref={childRef}
            checked={value}
            disabled={disabled || disableFieldWhen==true}
            onChange={handleChange}
            icon_off={configFile.icon_off}
            icon_on={configFile.icon_on}
            size={configFile.size?configFile.size:"1x"}
          />
        );
        break;
      case FormInputTypes.TEXT_INPUT.TEXT:
      case FormInputTypes.TEXT_INPUT.COLOR:
      case FormInputTypes.TEXT_INPUT.TIME:
      case FormInputTypes.TEXT_INPUT.EMAIL:
      case FormInputTypes.TEXT_INPUT.NUMBER:
      case FormInputTypes.TEXT_INPUT.PASSWORD:
      case FormInputTypes.TEXT_INPUT.URL:
        contenCell = (
          <InputText
            id={id}
            disabled={disabled?disabled:handleParentEnabledWhen()}
            configFile={configFile}
            ref={childRef}
            name={name + id}
            type={type}
            value={value}
            onChange={handleChange}
            data
          />
          
        );
        break;
      case FormInputTypes.SELECT:
        if (multiple === true) {
          contenCell = (
            <>
            <FormSelect
              id={id}
              ref={childRef}
              options={options}
              value={value}
              multiple
              writable={configFile.writable}
              onChange={handleChange}
            />
            </>
          );
        }else{
          if(configFile.emptyValue==true){
            contenCell = (
              <FormSelect
                id={id}
                ref={childRef}
                options={options}
                value={value}
                canEdit={configFile.canEdit}
                canCreate={configFile.canCreate}
                canFilter={configFile.canFilter}
                emptyValue={configFile.emptyValue}
                writable={configFile.writable}
                onChange={handleChange}
              />);
          }else{
            contenCell = (
              <Select
                id={id}
                ref={childRef}
                options={options}
                // eslint-disable-next-line no-nested-ternary
                value={typeof value === 'object' ? value[0] : value}
                onChange={handleChange}
                validation={FormValidation.PENDING}
              />
            );
          }
        }
        break;
      case FormInputTypes.CHECKBOX:
        
        contenCell = (
         <Checkbox
            id={id}
            className={(configFile.className?configFile.className:'')+" table__checkbox-radio"}
            ref={childRef}
            checked={value}
            disabled={disabled || disableFieldWhen==true}
            onChange={handleChange}
          />
        );
        break;
      case FormInputTypes.RADIO:
        contenCell = (
          <Radio
            id={id}
            className="table__checkbox-radio"
            ref={childRef}
            disabled={disabled?disabled:handleParentEnabledWhen()}
            checked={value === '' ? false : value}
            name={name}
            onChange={handleChange}
          />
        );
        break;
      case FormInputTypes.OTHER_RESOURCE:
        contenCell = (
          <FormLoadOtherResource
            id={id}
            configFile={configFile}
            calledId={id}
            value={value}
          />
        );
        break;
      case FormInputTypes.RELATIONSHIP:
        if (value !== null) {
          contenCell = (
            <FormRelationship
              id={id}
              configFile={configFile.configFile}
              value={value}
              onChange={handleChange}
              dataSet={dataSet}
            />
          );
        } else {
          contenCell = (
            <div></div>
          );
        }
        break;
      case FormInputTypes.RELATIONSHIPFILTER:
          contenCell = (
              <FormRelationshipFilter
                filterByParticularId={configFile.filterByParticularId}
                dataRow={dataSet[dataSetIndex]}
                id={id}
                isForm
                maxElements={configFile.maxElements}
                blockItemRemove={configFile.blockItemRemove}
                configFile={configFile.configFile}
                value={value?value:[]}
                onChange={handleChange}
            />
          );
          break;
      case FormInputTypes.TEXT_OR_RELATIONSHIP:
        contenCell = (
          <FormInputRelationship
            dataSet={dataSet}
            id={id}
            blockInput={blockInput}
            name={name + id}
            additionalUpdates={configFile.additionalUpdates?configFile.additionalUpdates:[]}
            configFile={configFile.configFile}
            value={value}
            popupSize={configFile.popupSize?configFile.popupSize:null}
            onChange={handleChange}
            hasTooltip={configFile.hasTooltip?configFile.hasTooltip:false}
          />
        );
        break;
      case FormInputTypes.DOWNLOADABLE:
            contenCell = (
              <FormExternalResource
                id={id}
                type={type}
                key={name + id}
                value={value}
                onChange={handleChange}
                hasSelect={hasSelect}
                fileType={configFile.fileType}
                imageHeight={configFile.imageHeight}
                imageWidth={configFile.imageWidth}
                columClass="col-sm-12"
              />
            );
            break;
      case FormInputTypes.TEXT_EDITOR:
        
        contenCell = (
        <TextEditor 
          key={name + id}
          id={id}
          value={value}
          onChange={handleChange}
          toolbar={configFile.toolbar}
        />);
        break;
        case FormInputTypes.DATE_PICKER_PARTIAL:
        contenCell = <FormDatePartialPicker
          id={id}
          value={value}
          onChange={handleChange}
          disabled={disabled ? disabled : handleParentEnabledWhen()}
          label={configFile.label || ''}
          helpText={configFile.helpText || ''}
          validation={FormValidation.PENDING}
        />
        break; 
      default:
        break;  
    }
  }
  else {
    if(type ==FormInputTypes.CHECKBOX){
      contenCell = (
       <Checkbox
          id={id}
          className="table__checkbox-radio"
          ref={childRef}
          checked={Boolean(value)}
          disabled={true}
          onChange={handleChange}
        />
      );
    }
    if(type == FormInputTypes.DOWNLOADABLE){
      contenCell = (
        <FormExternalResource
          id={id}
          type={type}
          key={name + id}
          value={value}
          fileType={fileType}
          onChange={handleChange}
          hasSelect={false}
          canUpload={false}
          canUpdate={false}
          canDelete={false}
          columClass="col-sm-12"
        />
      );
    }
  }
  if(type==FormInputTypes.TAG){
    contenCell = (
      <FormTag configFile={configFile} value={value}/>
    );
  }
  
  if(type==FormInputTypes.AUDIT_CHANGES){
    if (value !== null) {
      contenCell=(
          <FormAuditChanges
            id={id}
            configFile={configFile.configFile}
            value={dataSet[dataSetIndex]?.uuid ?? null}
            onChange={handleChange}
            dataSet={dataSet[dataSetIndex]}
            isForm={false}
          />
      );
    }
    else {
      contenCell = (
        <div></div>
      );
    }
  }
  if(type==FormInputTypes.RELATIONSHIP){
    if (value !== null) {
      contenCell=(
          <FormRelationship
            id={id}
            configFile={configFile.configFile}
            value={value}
            onChange={handleChange}
            dataSet={dataSet}
            canEdit={configFile.canEdit}
          />
      );
    }
    else {
      contenCell = (
        <div></div>
      );
    }
  }
  if(type == FormInputTypes.COLOR_PICKER){
    let myBackround=null;
    if(value){
      myBackround=value;
    }
    contenCell = (
      <div className="text-right">
        {value && <div>
          {value}<div style={{border:"1px solid #343A40",display:"inline-block",marginLeft:"10px",width:"20px",backgroundColor:value}}>&nbsp;</div>
        </div>}
      </div>
    );
  }
  if(type == FormInputTypes.MORE){
    contenCell = (
      <FormMoreInfo 
        id={id} 
        value={value}
        popupSize={configFile.size}
      />
    );
  }
  if(type == FormInputTypes.TEXT){
    contenCell = (
      <div>{typeof value == "string" ? value : value.toString()}</div>
    );
  }
  if (type === FormInputTypes.CELL_DATE) {
    contenCell = (
      <FormCellDate 
        id={id}
        value={value}
        mode={configFile.mode?configFile.mode:''}
      />
    );
  }
  if (type === FormInputTypes.STATUS) {
    contenCell = (
      <FormStatus
        id={id}
        value={value}
        info={secondaryValue}
        dataSet={dataSet}
        colors={colors}
        buttonText={buttonText}
        valueButton={valueButton}
        textAreYouSure={textAreYouSure}
        actionUrl={actionUrl}
        relatedId={relatedId}
        small={small}
        refreshRowOnChange={configFile.refreshRowOnChange}
        onChange={handleStatusChange}
        onChangeRow={handleChange}
      />
    );
  }
  if (type === FormInputTypes.AUDIO) {
    contenCell = (
      <Audio
        id={id}
        value={value}
      />
    );
  }
  if (type === FormInputTypes.COUNTRY_FLAG && value !== 'not found' && value !== '') {
    contenCell = (
      <Flag
        id={id}
        code={value}
      />
    );
  }
  if (type === FormInputTypes.PLAYERICONS){
    contenCell=(
      <PlayerIcon value={value} />
    );
  }
    
  if (type === FormInputTypes.TIMESTAMP) {
    contenCell = (
      <Timestamp
        id={id}
        value={value}
        mode={configFile.mode?configFile.mode:''}
      />
    );
  }
  if (type === FormInputTypes.TIMESTAMPMS) {
    contenCell = (
      <Timestamp
        id={id}
        value={value/1000}
        mode={configFile.mode?configFile.mode:''}
      />
    );
  }  
  if (type === FormInputTypes.TAGS_PREVIEW) {
    contenCell = (<>
    {value && <SingleTagPreview value={JSON.parse(value)} />}
    </>);
  }
  if (type === FormInputTypes.TIME) {
    contenCell = (
      <Time
        id={id}
        value={value}
        timelineType={secondaryValue}
        mode={configFile.mode?configFile.mode:''}
      />
    );
  }
  if (type === FormInputTypes.ARRAY) {
    contenCell = (
      <div>
        {value && value.map((element,index)=>{
          let v="";
          if(index!=0){
            v=v+", ";
          }
          v = v +configFile.fields.map((field,index)=>{
             return  element[field];
          }).join("-");
          return v;
        })}
        </div>
    );
  }
  let customIconObj=null;
  if (type === FormInputTypes.LINK) {
    if(configFile.iconWhen){
      customIconObj=checkIconWhen(configFile.iconWhen);
    }
    contenCell = (
      <>
      <ExternalLink
        id={id}
        icon={icon}
        customIcon={customIconObj}
        to={value}
        iconSize={configFile.iconSize}
        target={configFile.target}
        iconColor={configFile.iconColor}
        postUrl={configFile.postUrl}
        swalTitle={configFile.swalTitle}
        swalText={configFile.swalText}
        onChange={handleChangeExternal}
        disabled={configFile.disabled}
        hasClick={configFile.hasClick!=undefined?configFile.hasClick:undefined}
        emptyValue={configFile.emptyValue==true?configFile.emptyValue:false}
      />
      </>
    );
  }
  if (type === FormInputTypes.LINKFRAME) {
    if(configFile.iconWhen){
      customIconObj=checkIconWhen(configFile.iconWhen);
    }
    contenCell = (
      <>
      <ExternalFrame
        id={id}
        icon={icon}
        value={value}
        iconSize={configFile.iconSize}
        iconColor={configFile.iconColor}
        postUrl={configFile.postUrl}
      />
      </>
    );
  }
  if (type === FormInputTypes.BUTTON_POPUP) {
    contenCell = (     
      <ButtonPopup
        id={id}
        icon={icon}
        disabled={disabled?disabled:handleEnabledWhen()}
        iconSize={configFile.iconSize}
        redirectUrl={configFile.redirectUrl}
        actionUrl={configFile.actionUrl}
        refreshIfOk={configFile.refreshIfOk}
        openUrl={configFile.openUrl}
        iconColor={configFile.iconColor}
        formConfig={configFile.formConfig}
        value={value}
        sessionParams={sessionParams?sessionParams:[]}
      />
    );
  }
  if (type === FormInputTypes.POPUPTABLE) {
    contenCell = (
      <ExternalLink
        id={id}
        icon={icon}
        to={value}
        iconSize={configFile.iconSize}
        target={configFile.target}
        iconColor={configFile.iconColor}Icon
        openPopup={true}
        configTable={configFile.table}
      />
    );
  }

  if (type === FormInputTypes.BUTTON) {
    contenCell = (
      <Button
        id={id}
        type={ButtonType.BUTTON}
        theme={ButtonTheme.INFO}
        onClick={handleChange}
      >
        {label}
      </Button>
    );
  }
  if(type===FormInputTypes.TEXT_INPUT.LINK) {
    contenCell = (
      <a href={value} target="_blank">{value}</a>

    );
  }

  let colStyles={};
  colStyles.overflowWrap= 'break-word';
  if(small==true){
    colStyles.paddingLeft=0;
    colStyles.paddingRight=0;
    colStyles.textAlign="center";
  }
  if(exactWidth){
    colStyles.width=exactWidth;
  }else if (width){
    colStyles.maxWidth=width;
  }
  return (
    <td className={[ hidden ? 'd-none' : '', additionalCss || '', classNameCell || ''].join(' ').trim()} style={colStyles}> 
      {contenCell}
    </td>
  );
};

TableCell.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  configFile: PropTypes.shape({}).isRequired,
  dataSetIndex: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  fileType: PropTypes.arrayOf(PropTypes.string),
  canEdit: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeInputRelationship: PropTypes.func,
  onChangeStatus: PropTypes.func,
  pattern: PropTypes.instanceOf(RegExp),
  secondaryValue: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  colors: PropTypes.shape({}),
  width: PropTypes.string,
};

TableCell.defaultProps = {
  id: -1,
  value: '',
  secondaryValue: undefined,
  canEdit: false,
  onChange: () => {},
  onChangeInputRelationship: () => {},
  onChangeStatus: () => {},
  pattern: undefined,
  colors: undefined,
  fileType: [],
  width: '',
};

export default TableCell;
